import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// All API calls include credentials (session_token cookie used for admin auth)
// X-Requested-With acts as a CSRF guard: browsers can't set custom headers cross-origin
// without a CORS preflight, and our backend only allows our own frontend.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "X-Requested-With": "graceful-garden" },
});

export const formatPrice = (n) =>
  Number(n).toLocaleString("en-US", { style: "currency", currency: "USD" });

export const formatDate = (iso) => {
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("en-US", {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  } catch {
    return iso;
  }
};

export const formatTime = (iso) => {
  try {
    const d = new Date(iso);
    return d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
  } catch {
    return "";
  }
};

/** Format a "YYYY-MM-DD" date (wall-clock, no timezone) → "Friday, July 10, 2026". */
export const formatClassDate = (dateStr) => {
  if (!dateStr) return "";
  try {
    // Force noon UTC so the date label never slips a day in any browser locale
    const d = new Date(`${dateStr}T12:00:00Z`);
    return d.toLocaleDateString("en-US", {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  } catch {
    return dateStr;
  }
};

/** "09:00" → "9:00 AM" (24h string → 12h label). */
export const formatTime24 = (hhmm) => {
  if (!hhmm) return "";
  const [hStr, mStr = "00"] = String(hhmm).split(":");
  let h = parseInt(hStr, 10);
  if (Number.isNaN(h)) return hhmm;
  const ampm = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return `${h}:${mStr.padStart(2, "0")} ${ampm}`;
};

/** "09:00", "12:00" → "9:00 AM – 12:00 PM". Falls back gracefully if end is missing. */
export const formatTimeRange = (start, end) => {
  const s = formatTime24(start);
  const e = formatTime24(end);
  if (s && e) return `${s} – ${e}`;
  return s || e || "";
};

/** Combined class display: prefer the new separated fields, fall back to legacy date_time_iso. */
export const formatClassWhen = (cls) => {
  if (!cls) return "";
  const datePart = cls.class_date
    ? formatClassDate(cls.class_date)
    : formatDate(cls.date_time_iso);
  const timePart = formatTimeRange(cls.start_time, cls.end_time)
    || formatTime(cls.date_time_iso);
  return timePart ? `${datePart} · ${timePart}` : datePart;
};
